/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAliasesRequest
 */
export interface GetAliasesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetAliasesRequest
     */
    saids: Array<string>;
}

/**
 * Check if a given object implements the GetAliasesRequest interface.
 */
export function instanceOfGetAliasesRequest(value: object): boolean {
    if (!('saids' in value)) return false;
    return true;
}

export function GetAliasesRequestFromJSON(json: any): GetAliasesRequest {
    return GetAliasesRequestFromJSONTyped(json, false);
}

export function GetAliasesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAliasesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'saids': json['saids'],
    };
}

export function GetAliasesRequestToJSON(value?: GetAliasesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'saids': value['saids'],
    };
}

